import { NgModule } from "@angular/core";
import { IconComponent } from "./icon.component";
import { CommonModule } from "@angular/common";
import { IconCircleColorDirective } from "../shared/directives/icon-circle-color.directive";

@NgModule({
	declarations: [IconComponent, IconCircleColorDirective],
	imports: [CommonModule],
	exports: [IconComponent, IconCircleColorDirective]
})
export class IconModule {}
